module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opportunity"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasAuthorize),
      expression: "!hasAuthorize"
    }],
    staticClass: "auth-mask"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "title-tip"
  }, [_vm._v("登录即可获得更好的服务")]), _vm._v(" "), _c('input', {
    staticClass: "auth-btn",
    attrs: {
      "type": "button",
      "value": "微信快捷登录",
      "id": "authorize"
    },
    on: {
      "click": _vm.authorize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "auth-cancel",
    on: {
      "click": _vm.cancelAuthorize
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData),
      expression: "formData"
    }],
    staticClass: "oppo-main",
    attrs: {
      "id": "oppo-main"
    }
  }, [_c('div', {
    staticClass: "detail-main-container",
    staticStyle: {
      "margin-top": "35vh"
    },
    attrs: {
      "id": "detail-main-container"
    }
  }, [_c('div', [_vm._l((_vm.formData), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [(item.FieldType.toLowerCase() === 'text' && item.FieldCode.toLowerCase() !== 'city') ? _c('div', {
      staticClass: "item-wrap item_field"
    }, [_c('input', {
      staticClass: "field-type icon",
      class: item.FieldCode,
      attrs: {
        "name": item.FieldCode,
        "type": "text",
        "data-require": item.IsMust,
        "data-field-name": item.FieldName,
        "placeholder": item.IsMust ? item.FieldName + ' (必填) ' : item.FieldName
      },
      domProps: {
        "value": item.Default
      },
      on: {
        "blur": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust)
        },
        "input": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust, 'changeInput')
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error hidden",
      class: item.FieldCode.toLocaleLowerCase()
    }), _vm._v(" "), (['CompanyName'].includes(item.FieldCode) && _vm.companyList.length) ? _c('ul', {
      staticClass: "search_list"
    }, _vm._l((_vm.companyList), function(item, index) {
      return _c('li', {
        key: index,
        on: {
          "click": function($event) {
            return _vm.chooseItem(item.Name)
          }
        }
      }, [_vm._v(_vm._s(item.Name))])
    }), 0) : _vm._e()]) : (item.FieldType.toLowerCase() === 'text' && item.FieldCode.toLowerCase() === 'city') ? _c('div', {
      staticClass: "item-wrap"
    }, [_c('popup-picker', {
      staticClass: "field-type icon",
      class: item.FieldCode,
      attrs: {
        "name": item.FieldCode,
        "data": _vm.citys,
        "placeholder": item.IsMust ? item.FieldName + ' (必填) ' : item.FieldName,
        "columns": 2,
        "value-text-align": "left",
        "display-format": _vm.formatPicker
      },
      on: {
        "on-hide": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust)
        }
      },
      model: {
        value: (_vm.city),
        callback: function($$v) {
          _vm.city = $$v
        },
        expression: "city"
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "field-type",
      class: item.FieldCode,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "name": item.FieldCode,
        "type": "text",
        "data-require": item.IsMust,
        "data-field-name": item.FieldName,
        "placeholder": item.IsMust ? item.FieldName + ' (必填) ' : item.FieldName
      },
      domProps: {
        "value": _vm.city ? _vm.city[1] : undefined
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error hidden",
      class: item.FieldCode.toLocaleLowerCase()
    })], 1) : _vm._e(), _vm._v(" "), _c('div'), _vm._v(" "), (item.FieldType.toLowerCase() === 'validcode') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.Default === ''),
        expression: "item.Default===''"
      }],
      staticClass: "item-wrap valicodeWrap"
    }, [_c('input', {
      staticClass: "field-type icon",
      class: item.FieldCode,
      staticStyle: {
        "flex": "2.5"
      },
      attrs: {
        "name": "validCode",
        "type": "tel",
        "data-require": "1",
        "maxlength": "4",
        "placeholder": item.IsMust ? item.FieldName + ' (必填) ' : item.FieldName
      },
      on: {
        "keyup": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust)
        },
        "change": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust)
        },
        "blur": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust)
        }
      }
    }), _vm._v(" "), _c('div', {
      ref: "verifyCode",
      refInFor: true,
      staticClass: "verifyCode",
      on: {
        "click": _vm.sendSms
      }
    }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
      staticClass: "error hidden",
      class: item.FieldCode.toLocaleLowerCase()
    })]) : _vm._e(), _vm._v(" "), (item.FieldType.toLowerCase() === 'checkbox' || item.FieldType.toLowerCase() === 'radio') ? _c('div', {
      staticClass: "item-wrap"
    }, [_c('div', {
      staticClass: "checkbox-wrap",
      attrs: {
        "data-require": item.IsMust,
        "data-name": item.FieldCode
      }
    }, [_c('label', {
      staticStyle: {
        "display": "block",
        "width": "100%",
        "font-size": "16px"
      }
    }, [_c('span', {
      staticClass: "wrap-item"
    }, [_vm._v(" " + _vm._s(item.IsMust ? item.FieldName + ' (必填)' : item.FieldName))]), _vm._v(" "), _c('span', {
      staticClass: "error hidden",
      class: item.FieldCode.toLocaleLowerCase(),
      staticStyle: {
        "right": "0"
      }
    })]), _vm._v(" "), _vm._l((item.DictionarySet.split(item.Separator)), function(g, index) {
      return _c('div', {
        class: _vm.getCheckBoxClass(item)
      }, [_c('input', {
        attrs: {
          "type": item.FieldType.toLowerCase(),
          "name": item.FieldCode,
          "id": item.FieldCode + '-' + index,
          "data-field-name": item.FieldName
        },
        domProps: {
          "value": g
        },
        on: {
          "click": function($event) {
            return _vm._change('checkbox', item.FieldCode, item.IsMust)
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": item.FieldCode + '-' + index
        }
      }, [_vm._v(_vm._s(g))])])
    })], 2)]) : _vm._e(), _vm._v(" "), (item.FieldType === 'number') ? _c('div', {
      staticClass: "item-wrap"
    }, [_c('input', {
      staticClass: "field-type icon",
      class: item.FieldCode,
      attrs: {
        "name": item.FieldCode,
        "type": item.FieldCode === 'Phione' ? 'tel' : 'number',
        "default-value": item.Default,
        "data-require": item.IsMust,
        "data-field-name": item.FieldName,
        "maxlength": item.FieldCode === 'Phione' ? '11' : '',
        "placeholder": item.IsMust ? item.FieldName + ' (必填) ' : item.FieldName
      },
      domProps: {
        "value": item.Default
      },
      on: {
        "input": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust)
        },
        "blur": function($event) {
          return _vm._change('input', item.FieldCode, item.IsMust)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error hidden",
      class: item.FieldCode.toLocaleLowerCase()
    })]) : _vm._e(), _vm._v(" "), (item.FieldType === 'textarea') ? _c('div', {
      staticClass: "item-wrap"
    }, [_c('textarea', {
      staticClass: "field-type",
      class: item.FieldCode,
      staticStyle: {
        "width": "100%",
        "height": "50px"
      },
      attrs: {
        "name": item.FieldCode,
        "data-require": item.IsMust,
        "data-field-name": item.FieldName,
        "placeholder": item.FieldName
      },
      domProps: {
        "value": item.Default
      },
      on: {
        "input": function($event) {
          return _vm._change('textarea', item.FieldCode, item.IsMust)
        },
        "blur": function($event) {
          return _vm._change('textarea', item.FieldCode, item.IsMust)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error hidden",
      class: item.FieldCode.toLocaleLowerCase()
    })]) : _vm._e()])
  }), _vm._v(" "), _c('input', {
    staticClass: "btn",
    style: (("background-color:" + _vm.submitBgColor)),
    attrs: {
      "type": "button",
      "value": _vm.submitText,
      "id": "submitBtn"
    },
    on: {
      "click": _vm.submit
    }
  })], 2)])]), _vm._v(" "), _c('j-alert', {
    attrs: {
      "content": _vm.errContents,
      "show": _vm.isShowErr,
      "onHide": _vm.onHide
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loaded),
      expression: "!loaded"
    }],
    staticClass: "loading"
  }, [_vm._m(1)]), _vm._v(" "), _c('j-alert', {
    attrs: {
      "title": "",
      "content": _vm.alertContent,
      "show": _vm.isShowAlert,
      "onHide": _vm.hideAlert
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "title-logo",
    attrs: {
      "src": "https://huiyuanxitong.oss-cn-hangzhou.aliyuncs.com/dhy/pub/d16325534c06a3bfd423fd29c4248c7ded6366b9.png",
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-inner line-scale"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f5e4b30"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/opportunity.vue
// module id = 279
// module chunks = 1